<template>
    <div class="long-text">
        <textarea
                class="tw-w-full tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0"
                :style="style"
                :required="config.required"
                :readonly="readonly"
                :value="value"
                @keyup="onAnswerInput" @paste="onAnswerInput"
                rows="4"
        >
        </textarea>
    </div>
</template>

<script>
export default {
    name: 'QuestionLongText',
    props: {
        value: {
            type: String,
            default: ''
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            style: {},
        }
    },
    watch: {
        value: {
            handler(value) {
                this.answer(value);
            },
            immediate: true
        },
        inputStyles() {
            this.style = this.inputStyles;
            this.style.fontSize = Math.floor(parseInt(this.style.fontSize) * 0.7)+'px';
        }
    },
    methods: {
        onAnswerInput(event) {
            this.answer(event.target.value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: true,
            });
        },
        sizeCheck() {
            this.style = this.inputStyles;
            this.style.fontSize = Math.floor(parseInt(this.style.fontSize) * 0.7)+'px';
        }
    },
    mounted() {
        this.sizeCheck();
    }
}
</script>
